export interface Currency {
  symbol: string;
  name: string;
  code: string;
  namePlural: string;
  symbolNative: string;
  subTitle?: string;
}

export interface CurrencySelectionStepProps {
  selectedCurrency: string | null;
  currenciesArray: Currency[];
  setSelectedCurrency: React.Dispatch<React.SetStateAction<string>>;
  indicatorComponent?: React.ComponentType<any>;
  disabled?: boolean;
  classes?: string;
  error?: string;
  sessionCurrency?: string | null;
  processingCurrency?: string | null;
  providerCurrency?: string | null;
  outline?: string;
  backgroundColor?: string;
  controlBackgroundColor?: string;
}

export interface CurrencyOption {
  ref: React.RefObject<HTMLDivElement> | null;
  label: string;
  value: string;
  isFocusedByKeyboard: boolean;
}

export enum SelectKeyboardListenersNames {
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  ARROW_DOWN = 'ArrowDown',
  ARROW_UP = 'ArrowUp',
  BACKSPACE = 'Backspace',
  DELETE = 'Delete',
}
